import { useEffect, useState } from "react";
import {
  usePipelineStatusCommentGetDataLazyQuery,
  useSetPipelineStatusCommentMutation
} from "@bonliva-crm/graphql";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from "@material-ui/core";
import { TextField, useSnackbarsPipeline } from "@bonliva-crm/ui";
import locale from "@bonliva-crm/locale";

type Props = {
  open: boolean;
  consultantId: string | null;
  onClose: () => void;
};

export function EditStatusNoteDialog(props: Props) {
  const snack = useSnackbarsPipeline();
  const [note, editNote] = useState<string>("");

  const [load, { loading }] = usePipelineStatusCommentGetDataLazyQuery({
    onCompleted: (data) => {
      editNote(data.consultantById?.pipelineStatusComment || "");
    },
    fetchPolicy: "network-only"
  });

  const [updateComment, commentMutation] = useSetPipelineStatusCommentMutation();

  useEffect(() => {
    if (props.open && props.consultantId) {
      load({
        variables: {
          consultantId: props.consultantId
        }
      });
    }
  }, [props.open, props.consultantId, load]);

  const submit = () => {
    updateComment({
      variables: {
        consultantId: props.consultantId,
        comment: note
      }
    })
      .then(() => {
        snack.showSuccess(locale.updated);
        props.onClose();
      })
      .catch((e) => {
        snack.showError(locale.somethingWentWrong);
        console.error(e);
      });
  };

  const canSubmit = !loading || !commentMutation.loading;

  if (loading) {
    return (
      <Dialog open={props.open}>
        <DialogContent>
          <CircularProgress />
        </DialogContent>
      </Dialog>
    );
  }

  return (
    <Dialog open={props.open} onClose={props.onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{locale.editNote}</DialogTitle>

      <DialogContent>
        <TextField
          multiline
          fullWidth
          minRows={4}
          maxRows={4}
          value={note}
          onChange={(e) => {
            editNote(e.target.value);
          }}
        />
      </DialogContent>

      <DialogActions>
        <Button variant="outlined" color="primary" onClick={props.onClose}>
          {locale.Cancel}
        </Button>

        <Button
          variant="contained"
          color="primary"
          onClick={() => submit()}
          disabled={!canSubmit}
        >
          {locale.Save}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
